export default "__VITE_PUBLIC_ASSET__dd13317e__"